import { render, staticRenderFns } from "./NavBottom.vue?vue&type=template&id=14bff1ce&scoped=true&"
import script from "./NavBottom.vue?vue&type=script&lang=js&"
export * from "./NavBottom.vue?vue&type=script&lang=js&"
import style0 from "./NavBottom.vue?vue&type=style&index=0&id=14bff1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bff1ce",
  null
  
)

export default component.exports